export const authenticationCookieName = "auth_token";
export const refreshCookieName = "refresh_token";
export const isMobileCookieName = "is_mobile_app";
